import Layout from './layout'
import ListingSummaryForm from './form-summary'
import useParamsLoadListing from './hooks/use-parms-load-listing'

const ListingSummary = () => {
  const { listing, isLoading } = useParamsLoadListing()

  return (
    <Layout data={listing} step="listing-summary">
      <ListingSummaryForm data={listing} isLoading={isLoading} />
    </Layout>
  )
}

export default ListingSummary
